import Vue from 'vue'
import Router from 'vue-router'

// Dashboard Components
import home from '../views/home'
import map from '../views/map'
import presale from '../views/presale-pre'
import presale2 from '../views/presale-detail'
import presale3 from '../views/presale-basic'
import reward from '../views/reward'
import signin from '../views/signin'
import account from '../views/account'
import land from '../views/land'
import event from '../views/event'
import presale_1st from '../views/presale_1st'
import mainsale_pre from '../views/mainsale-pre'
import mainsale_1st from '../views/mainsale_1st'

import AppHeader from '../components/partials/AppHeader';
import AppFooter from '../components/partials/AppFooter';

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    components: { default: home, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }
  }, {
    path: '/map',
    name: 'map',
    components: { default: map, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }
  }, {
    path: '/map/:landId',
    name: 'map',
    components: { default: map, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }
  }, {
    path: '/presale',
    name: 'presale',
    components: { default: presale_1st, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }
  }, {
    path: '/mainsale',
    name: 'mainsale',
    components: { default: mainsale_1st, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }    
  }, {
    path: '/reward',
    name: 'reward',
    components: { default: reward, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: 'orange' }
    }
  }, {
    path: '/signin',
    name: 'signin',
    components: { default: signin, header: AppHeader, footer: AppFooter },
  }, {
    path: '/account',
    name: 'account',
    components: { default: account, header: AppHeader, footer: AppFooter },
  }, {
    path: '/account/:tab',
    name: 'account',
    components: { default: account, header: AppHeader, footer: AppFooter },
  }, {
    path: '/land/:landId',
    name: 'land',
    components: { default: land, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }
  }, {
    path: '/land',
    name: 'land',
    components: { default: land, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }
  }, {
    path: '/event',
    name: 'event',
    components: { default: event, header: AppHeader, footer: AppFooter },
    props: {
      header: { colorOnScroll: 50 },
      footer: { backgroundColor: 'orange' }
    }
  }]
})
